import * as React from "react";
import Svg, { Path } from "react-native-svg";

const CircleChart = (props) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M10 1.25A8.75 8.75 0 1 0 18.75 10 8.76 8.76 0 0 0 10 1.25Zm0 16.25a7.5 7.5 0 0 1 0-15V10l5.3 5.3a7.474 7.474 0 0 1-5.3 2.2Z"
      fill={props.color}
    />
  </Svg>
);
CircleChart.defaultProps = {
  color: "#419AB1",
};
export default CircleChart;
